export const PartsCustomerSuppliedColumnsModel = [
  {
    label: 'Customer Number',
    type: 'string',
    property: 'number',
    isVisible: true
  },
  {
    label: 'Customer Name',
    type: 'string',
    property: 'name',
    isVisible: true
  }
];
